if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Sticky header

			if (this.hasAttribute('data-sticky-header')) {

			const stickyHeader = document.createElement('div');
			stickyHeader.className = 'sticky-header';

			const topHtml = this.querySelector('.header__top')?.innerHTML || '';
			const bottomHtml = this.querySelector('.header__bottom')?.innerHTML || '';
			const searchDrawer = this.querySelector('#search-drawer');

			stickyHeader.innerHTML = `
				<div class="header__bottom header-container container--large portable-hide">
				${bottomHtml}
				</div>
				<div class="site-header header__top container--large">
				${topHtml}
				</div>
			`;

			if (searchDrawer) {
				const stickySearchDrawer = searchDrawer.cloneNode(true);
				stickySearchDrawer.id = 'search-drawer-sticky';
				stickyHeader.appendChild(stickySearchDrawer);
			}

			const stickyTrigger = stickyHeader.querySelector('#search-drawer-trigger');
			if (stickyTrigger) {
				stickyTrigger.id = 'search-drawer-trigger-sticky';
				stickyTrigger.setAttribute('aria-controls', 'search-drawer-sticky');
			}

			document.body.append(stickyHeader);

			window.lst = window.scrollY;
			window.lhp = 0;

			const stickyHeaderDeskBound = this.querySelector('.header__bottom');
			const stickyHeaderMobileBound = this.querySelector('.header__top');

			this.SCROLL_StickyHelper = () => {
				var st = window.scrollY;

				if ((st <= 0 || stickyHeaderMobileBound.getBoundingClientRect().top >= 0) && stickyHeader.classList.contains('show')) {
				stickyHeader.classList.remove('show');
				return;
				}

				if (st < 0 || Math.abs(window.lst - st) <= 5) return;

				if (st > window.lhp) {
				if (st == 0 && stickyHeader.classList.contains('show')) {
					stickyHeader.classList.remove('show');
				} else if (st <= window.lst && !stickyHeader.classList.contains('show')) {
					window.lhp = stickyHeader.offsetTop;
					stickyHeader.classList.add('show');
				} else if (st > window.lst && stickyHeader.classList.contains('show')) {
					stickyHeader.classList.remove('show');
				}
				}

				window.lst = st;
			};

			window.addEventListener('scroll', this.SCROLL_StickyHelper, { passive: true });

			if (typeof window.ShopSanteRunMacy === 'function') {
				window.ShopSanteRunMacy(stickyHeader);
			} else if (typeof Macy !== 'undefined') {
				stickyHeader.querySelectorAll('.submenu-masonry:not([data-macy-initialized])').forEach(elm => {
					elm.dataset.macyInitialized = 'true';
					const submenuMacy = new Macy({
						container: elm,
						columns: elm.classList.contains('with-promotion') ? 3 : 4,
						margin: { x: 0, y: 32 },
					});
					setTimeout(() => {
						submenuMacy.reInit();
					}, 100);
				});
			}

			if (localStorage.getItem('selected-store')) {
				const stick = stickyHeader.querySelector('#shipping-fee');
				if (stick) {
				stick.checked = true;
				}
			}
			}

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			})

			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if(localStorage.getItem('selected-store') ||  !elm.querySelector('#shipping-fee').checked){
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment

			
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm => {
				elm.addEventListener('mouseover', () => {
					const submenu = elm.querySelector('.normal-menu');
					if (!submenu) return;

					const parent = submenu.offsetParent || submenu.parentElement || document.body;
					const parentRect = parent.getBoundingClientRect();
					const elmRect = elm.getBoundingClientRect();
					const rtl = document.documentElement.getAttribute('dir') == 'rtl';

					const left = rtl
					? (elmRect.right - parentRect.left) - submenu.offsetWidth
					: (elmRect.left  - parentRect.left);

					submenu.style.left  = rtl ? 'auto' : `${left}px`;
					submenu.style.right = rtl ? `${parentRect.right - elmRect.right}px` : 'auto';
					
				});
			});

			// predictive search

			if (JSON.parse(document.getElementById('shopify-features').text).predictiveSearch) {
			document.querySelectorAll('search-form [data-js-search-input]').forEach(elm => {
				elm.addEventListener('focus', () => {
				const results = elm.closest('search-form')?.querySelector('[data-js-search-results]');
				results?.classList.add('active');

				if (!document.body.classList.contains('predictive-script-loaded')) {
					document.body.classList.add('predictive-script-loaded');
					const predictiveSearchJS = document.createElement('script');
					predictiveSearchJS.src = KROWN.settings.predictive_search_script;
					document.head.appendChild(predictiveSearchJS);
				}
				});

				elm.addEventListener('keydown', e => {
				if (e.keyCode == window.KEYCODES.TAB) {
					const results = elm.closest('search-form')?.querySelector('[data-js-search-results]');
					results?.classList.remove('active');
				}
				});
			});

			window.addEventListener('load', () => {
				document.querySelectorAll('[data-js-search-results]').forEach(elm => {
				elm.style = '';
				});
			});
			} else {
				document.querySelector('search-form [data-js-search-input] + button').classList.add('button--invisibile-trigger');
			}

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'true');
						}
					}
				});

				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

			document.querySelectorAll('[aria-controls="search-drawer"], [aria-controls="search-drawer-sticky"]').forEach(trigger => {
				const drawerId = trigger.getAttribute('aria-controls');
				const drawer = document.getElementById(drawerId);

				if (!drawer) return;

				trigger.addEventListener('click', e => {
					e.preventDefault();
					drawer.classList.toggle('active');

					if (drawer.classList.contains('active')) {
					drawer.querySelector('input')?.focus();
					} else {
					trigger.focus();
					}
				});
			});

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}

  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/*
			* generic hide/show functions
		*/

		show(){
            displayDonationMessageCartDrawer()
			this.opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = '';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);
			if ( this.id == "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
				if ( document.querySelector('.upsell-container css-slider') ) {
					document.querySelector('.upsell-container css-slider').resetSlider();
				}
        InitSubmit();
			}

		}

		hide(){
			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`).setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {

	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu')
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu')
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

			if ( this.dataset.showHeaderActions == 'true' ) {

				const mobileNavActions = document.createElement('div');
				mobileNavActions.classList = "header-actions flex-buttons";
				mobileNavActions.innerHTML = document.querySelector('[data-js-header-actions]').innerHTML;
				this.querySelector('nav').prepend(mobileNavActions);

				mobileNavActions.querySelectorAll('[data-modal]').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					})
				});

			}
			if(localStorage.getItem('selected-store')){
				const stick = this.querySelector('#shipping-fee');

				if(stick){
					stick.checked = true;
				}
			}
		}

		_resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.opened .submenu').scrollHeight}px`;
				}
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.checkNav();
			}, 200));
			this.checkNav();

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
		}

		checkNav() {
    if (!this.linkList || !this.header) return;

    if (this.linkList.scrollWidth > this.offsetWidth) {
        this.header.classList.add('scrolling-navigation-enabled');
    } else {
        this.header.classList.remove('scrolling-navigation-enabled');
    }
}

	}

  if ( typeof customElements.get('scrollable-navigation') == 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}

if ( typeof MenuDrawer !== 'function' ) {
	class MenuDrawer extends HTMLElement {
		constructor() {
			super();
			this.triggers = document.querySelectorAll(`[aria-controls="${this.id}"]`);

			document.addEventListener('keydown', e => {
				if (e.keyCode == window.KEYCODES.ESC) {
					if (this.opened) {
						this.hide();
					}
				}
			});

			this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          if (this.opened) {
            this.hide();
          } else {
            this.show();
          };
        });
      });
		}

		show() {
			this.opened = true;

			document.body.classList.add('menu-drawer-opened');
			if (this.classList.contains('menu-drawer--right')) {
				document.body.classList.add('menu-drawer-opened--right');
			} else if (this.classList.contains('menu-drawer--left')) {
				document.body.classList.add('menu-drawer-opened--left');
			}

			this.style.display = 'grid';
			this.triggers.forEach(trigger => {
			  trigger.setAttribute('aria-expanded', 'true');
      })

			setTimeout(() => {
				this.classList.add('menu-drawer--opened');
			});

      const announcementBarHeight = document.querySelector('announcement-bar')?.offsetHeight || 0;
      const headerHeight = document.querySelector('main-header .header-container--top')?.offsetHeight || 0;
      const stickyHeaderHeight = document.querySelector('.sticky-header.show')?.offsetHeight || 0;

      if (window.scrollY < (announcementBarHeight + headerHeight)) {
        this.style.setProperty('--menu-drawer-offset', `${(announcementBarHeight + headerHeight) - window.scrollY}px`);
      }
      else if (window.scrollY > (announcementBarHeight + headerHeight)) {
        this.style.setProperty('--menu-drawer-offset', `${stickyHeaderHeight}px`);
      }
      else {
        this.style.setProperty('--menu-drawer-offset', `${announcementBarHeight + headerHeight}px`);
      };
		}

		hide() {
			this.opened = false;
			this.classList.remove('menu-drawer--opened');

			document.body.classList.remove('menu-drawer-opened');
			document.body.classList.remove('menu-drawer-opened--left');
			document.body.classList.remove('menu-drawer-opened--right');

			this.triggers.forEach(trigger => {
			  trigger.setAttribute('aria-expanded', 'false');
      })

			setTimeout(() => {
				this.style.display = 'none';
			}, 300);
		}
	}

  if ( typeof customElements.get('menu-drawer') == 'undefined' ) {
		customElements.define('menu-drawer', MenuDrawer);
	}
}
